var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "classCompany" },
    [
      _c("div", { staticClass: "classCompany_wrap" }, [
        _c(
          "div",
          { staticClass: "classCompanyTitle" },
          [
            _c("p", [_vm._v("班级公司管理")]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { plain: "", size: "mini" },
                on: { click: _vm.createdClass }
              },
              [_vm._v("创建班级")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "classCompanyContent" }, [
          _c(
            "div",
            { staticClass: "cardAll" },
            _vm._l(_vm.classCompany, function(o, index) {
              return _c(
                "div",
                { key: index, staticClass: "box-card", staticStyle: {} },
                [
                  _c("img", {
                    staticStyle: {
                      height: "120px",
                      width: "215px",
                      "border-radius": "8px"
                    },
                    attrs: { src: o.companyLogo }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "20px", flex: "1" } },
                    [
                      _c(
                        "h3",
                        {
                          staticStyle: {
                            "font-size": "16px",
                            overflow: "hidden",
                            "text-overflow": "ellipsis",
                            "white-space": "nowrap",
                            "line-height": "25px"
                          },
                          attrs: { title: o.companyName }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(o.companyName) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            height: "38px",
                            background: "rgb(252 252 252)",
                            padding: "5px 5px"
                          }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                width: "100%",
                                overflow: "hidden",
                                display: "-webkit-box",
                                "-webkit-box-orient": "vertical",
                                "-webkit-line-clamp": "4",
                                "text-overflow": "ellipsis"
                              },
                              attrs: { title: o.companyContext }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(o.companyContext) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "margin-top": "20px"
                          }
                        },
                        [
                          _c("span", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "relative",
                                  "margin-right": "30px"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#0e56ad"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.open_dialog(o)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t公司业务管理\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "gsywgl" })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "relative",
                                  "margin-right": "30px"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#0e56ad"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.del(o)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t删除公司数据\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "del" })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "relative",
                                  "margin-right": "30px"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#0e56ad"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.employeeInformationTable(o)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t人事管理\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "rsgl" })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { position: "relative" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#0e56ad",
                                      display: "flex",
                                      "align-items": "center",
                                      "margin-top": "3px"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.enterOffice(o)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v("进入办公区 "),
                                    _c("i", { staticClass: "el-icon-right" })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "jrbgq" })
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "selectePages" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.totalObj.currentPage,
                  background: "",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.totalObj.pageSize,
                  layout: "sizes, prev, pager, next",
                  total: _vm.totalObj.total
                },
                on: {
                  "size-change": _vm.classCompanySizeChange,
                  "current-change": _vm.classCompanyCurrentChange,
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.totalObj, "currentPage", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.totalObj, "currentPage", $event)
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          staticStyle: { "border-radius": "25px" },
          attrs: {
            "destroy-on-close": "",
            width: "500px",
            visible: _vm.dialogVisible,
            title: "创建公司",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "公司名称", prop: "companyName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "290px" },
                    model: {
                      value: _vm.ruleForm.companyName,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "companyName", $$v)
                      },
                      expression: "ruleForm.companyName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "公司简介", prop: "companyContext" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "290px" },
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.ruleForm.companyContext,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "companyContext", $$v)
                      },
                      expression: "ruleForm.companyContext"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目引入", prop: "subjectId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "290px" },
                      attrs: { multiple: "", placeholder: "请选择项目" },
                      model: {
                        value: _vm.ruleForm.subjectId,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "subjectId", $$v)
                        },
                        expression: "ruleForm.subjectId"
                      }
                    },
                    _vm._l(_vm.subjectList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.projectName, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "upload_custom",
                  attrs: { label: "上传图片", prop: "companyLogo" }
                },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "addUpload",
                      attrs: {
                        limit: 1,
                        "file-list": _vm.flieList,
                        "list-type": "picture-card",
                        action: _vm.materialForm.url,
                        headers: _vm.headers,
                        "on-success": _vm.handleAvatarSuccess
                      }
                    },
                    [_c("i", { staticClass: "el-input__icon el-icon-plus" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.dialogVisible = false
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.handleSave("ruleForm")
                          }
                        }
                      },
                      [_vm._v("确 定")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36752708", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36752708","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/newRealTask/components/classCompany.vue
// module id = null
// module chunks = 